import styled from 'styled-components';

import {
  ButtonWrapper,
  ContentWrapper,
  Footer,
  Heading,
  ScrollContainer,
  Wrapper,
} from '../accept_terms_and_conditions/index.styles';

export { ButtonWrapper, ContentWrapper, Footer, Heading, ScrollContainer, Wrapper };

export const CheckboxWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--gap);
  margin-bottom: var(--gap);
`;
